<template>
  <el-menu :collapse="collapsed"
           collapse-transition
           unique-opened
           router
           :default-active="activeMenu"
           class="el-menu-vertical-demo"
           background-color="#304156"
           text-color="rgb(191, 203, 217)"
           active-text-color="rgb(64, 158, 255)">
    <template v-for="menu in permission_routes">
      <!--根据权限匹配好路由后，根据路由动态生成菜单（仅考虑生成有子菜单的菜单）-->
      <el-submenu v-if="!menu.hidden&&menu.meta&&menu.children&&menu.children.length>0"
                  :index="menu.path" :key="menu.path" popper-append-to-body>

        <template slot="title" v-if="menu.meta">
          <i class="iconfont" :class="menu.meta.icon"></i> &nbsp
          <span>{{menu.meta.title}}</span>
        </template>

        <el-menu-item-group>
          <div v-for="children in menu.children">
            <el-menu-item v-if="!children.hidden" :index="resolvePath(menu.path, children)"
                          :key="children.path" @click="handleClick(menu.path, children)">
              <template slot="title" v-if="children.meta">
                <i class="iconfont" :class="children.meta.icon"></i> &nbsp
                <span>{{children.meta.title}}</span>
              </template>
            </el-menu-item>
          </div>
        </el-menu-item-group>

      </el-submenu>
    </template>

  </el-menu>
</template>
<script>
  import path from 'path'
  import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        collapsed: false
      }
    },
    computed: {
      ...mapGetters([
        'permission_routes'
      ]),
      activeMenu() {
        const route = this.$route
        const {meta, path} = route
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      }
    },
    methods: {
      handleClick(basePath, menu) {
        if (menu.extra && menu.extra.isLink) {
          if (menu.extra.linkType === 'in') {
            const {href} = this.$router.resolve(path.resolve(basePath, menu.path))
            // console.log(href)
            window.open(href, '_blank');
          } else if (menu.extra.linkType === 'out') {
            window.open(menu.path, '_blank');
          }
        }
      },
      resolvePath(basePath, menu) {
        if (menu.extra && menu.extra.isLink) {
          return ''
        }
        return path.resolve(basePath, menu.path)
      }
    },
    created() {
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
    }
  }
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    min-height: 200px;
  }

  .el-submenu__title {
    height: 50px;
    line-height: 50px;
    font-size: 12px;
    color: #303133;
    padding: 0 20px;
    list-style: none;
    cursor: pointer;
    position: relative;
    -webkit-transition: border-color .3s, background-color .3s, color .3s;
    transition: border-color .3s, background-color .3s, color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #1f2d3d !important;
  }

  .el-menu {
    border: none;
  }

  .logobox {
    height: 42px;
    line-height: 42px;
    color: rgb(191, 203, 217);
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    padding: 10px 0px;
  }

  .logoimg {
    height: 22px;
  }

  .el-menu-item {
    font-size: 12px;
  }

  .iconfont {
    color: #bfcbd9 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue